module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8510/img/website-performance-rating.jpg"